// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"88":"c948d28d","182":"f411b8f3","239":"ffaf022c","376":"ea026727","466":"5d0063e9","965":"be544ba0"}[chunkId] + ".css";
};